<template>
  <div class="login-spacing">
    <h1>Einladung abgelehnt</h1>
    <div class="login-form-wrapper">

      <b-alert v-model="hasUnknownError" variant="danger">
        {{ unknownErrorMessage }}
      </b-alert>

      <b-alert variant="success" show>
        Sie haben die Einladung abgelehnt. Der Status wird entsprechend angepasst.
      </b-alert>

    </div>
  </div>
</template>

<script>
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      isSucceded: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: ''
    }),
    created () {
      this.checkInviteCode()
    },
    methods: {
      checkInviteCode () {
        const { inviteCode } = this.$route.query

        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('permission/PERMISSION_INVITE_DENY', inviteCode).then(res => {
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-spacing{
    margin-top: 7rem;
  }
  .login-form-wrapper{
    max-width: 400px;
    margin: 0 auto;
    text-align: left;
  }
</style>
